module.exports = __webpack_public_path__ + "img/Groupe 83.950ec418.svg";